import RedirectScreen from '@/screens/Auth/RedirectScreen/index.container';

export default RedirectScreen;
